/** IndexedDB — jeden plik, trzy magazyny: kv (konfiguracja/kompilat), txns
 * (transakcje offline, append-only), keys (CryptoKey urządzenia — structured
 * clone trzyma klucz NON-EXTRACTABLE, więc materiał klucza nie jest osiągalny
 * nawet przy pełnym zrzucie bazy). */

const DB_NAME = "smartlight";
const DB_VER = 1;

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VER);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains("kv")) db.createObjectStore("kv");
      if (!db.objectStoreNames.contains("txns"))
        db.createObjectStore("txns", { keyPath: "local_uuid" });
      if (!db.objectStoreNames.contains("keys")) db.createObjectStore("keys");
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx<T>(
  store: string, mode: IDBTransactionMode,
  fn: (s: IDBObjectStore) => IDBRequest<T> | IDBRequest,
): Promise<T> {
  const db = await open();
  return new Promise<T>((resolve, reject) => {
    const t = db.transaction(store, mode);
    const req = fn(t.objectStore(store));
    req.onsuccess = () => resolve(req.result as T);
    req.onerror = () => reject(req.error);
  });
}

export const kv = {
  get: <T>(key: string) => tx<T | undefined>("kv", "readonly", (s) => s.get(key)),
  set: (key: string, value: unknown) => tx("kv", "readwrite", (s) => s.put(value, key)),
  del: (key: string) => tx("kv", "readwrite", (s) => s.delete(key)),
};

export const keys = {
  get: (key: string) => tx<CryptoKeyPair | undefined>("keys", "readonly", (s) => s.get(key)),
  set: (key: string, value: CryptoKeyPair) => tx("keys", "readwrite", (s) => s.put(value, key)),
};

export interface StoredTxn {
  local_uuid: string;
  synced: boolean;
  envelope: string; // zaszyfrowana treść transakcji (AES-GCM) — patrz vault.ts
  chain_hash: string;
  created_at: string;
  // Paczka odrzucona przy synchronizacji NIE znika: bilety są już u podróżnych,
  // więc transakcja zostaje w magazynie z POWODEM odmowy i czeka na uzgodnienie
  // z operatorem. Bez tego jedynym śladem był komunikat w okienku, który kasjer
  // zamykał i który ginął razem z sesją.
  rejected_at?: string;
  rejected_reason?: string;
}

export const txns = {
  all: () => tx<StoredTxn[]>("txns", "readonly", (s) => s.getAll()),
  put: (t: StoredTxn) => tx("txns", "readwrite", (s) => s.put(t)),
};
